import React, { useEffect, useState } from "react";

import OfferModal from "./OfferModal";

import { FieldState } from "../../utils/ValidationFunctions";

import { getAuthToken } from "../../redux/reducers/auth";
import { useAppSelector, useAppDispatch } from "../../redux/hooks";
import { sendOfferRequest } from "../../redux/reducers/user";

import { postCreateChatroom } from "../../services/api/chat/postCreateChatroom";
import { postRoomCreationFailedReport } from "../../services/api/user/postRoomCreationFailedReport";

export const enum OfferRequestState {
  Waiting,
  Doing,
  Success,
  offerFailed,
  chatFailed,
}

type Props = {
  id: string;
  ownerId: string;
  ownerName: string;
  ownerChatDenial: boolean;
  recipientType: string;
  handleClose: () => void;
};

const OfferModalContainer: React.FC<Props> = ({
  id,
  ownerId,
  ownerName,
  ownerChatDenial,
  recipientType,
  handleClose,
}) => {
  const [fieldState, setFieldState] = useState<FieldState>({});
  const [invalidReason, setInvalidReason] = useState<boolean>(false);
  const [offerRequestState, setOfferRequestState] = useState<OfferRequestState>(
    OfferRequestState.Waiting
  );

  const auth_token = useAppSelector(getAuthToken);
  const dispatch = useAppDispatch();

  const handleSubmit = async () => {
    if (!auth_token) return;

    if (
      fieldState["sonic_type"]?.[0] === "5" &&
      !fieldState["sonic_other_reasons"]
    ) {
      setInvalidReason(true);
      return;
    }

    setOfferRequestState(OfferRequestState.Doing);

    const offer_args: { [key: string]: string } = {};

    for (const key in fieldState) {
      if (fieldState[key][1] == false) {
        return;
      }

      const val = fieldState[key][0];

      if (typeof val === "string") {
        offer_args[key] = val;
      }
    }

    const res = await dispatch(
      sendOfferRequest({ auth_token: auth_token, offer: offer_args })
    );

    if (!res.payload) {
      return setOfferRequestState(OfferRequestState.offerFailed);
    }

    const chatRes = await postCreateChatroom(
      auth_token,
      ownerId,
      "offer",
      res.payload
    );

    if (chatRes === null) {
      postRoomCreationFailedReport("offer", res.payload);
      return setOfferRequestState(OfferRequestState.chatFailed);
    }

    setOfferRequestState(OfferRequestState.Success);
  };

  const handleInputChange = (value: string | undefined, name: string) => {
    let f: FieldState = {};
    if (fieldState !== undefined) {
      f = fieldState;
    }

    if (value !== undefined) {
      f[name] = [value, true];
    } else {
      f[name] = ["", false];
    }
    setFieldState(f);
  };

  useEffect(() => {
    let f: FieldState = {};
    if (fieldState !== undefined) {
      f = fieldState;
    }

    f["sonic_to"] = [id, true];
    f["sonic_recipient_type"] = [recipientType, true];

    setFieldState(f);
  }, []);

  return (
    <OfferModal
      ownerName={ownerName}
      ownerChatDenial={ownerChatDenial}
      invalidReason={invalidReason}
      handleClose={() => {
        handleClose();
        setOfferRequestState(OfferRequestState.Waiting);
      }}
      handleSubmit={handleSubmit}
      handleInputChange={handleInputChange}
      offerRequestState={offerRequestState}
    />
  );
};

export default OfferModalContainer;
